import { BaseModel } from "./base/base.model";
import { Empleado } from "./empleado.model";

export class Sustitucion extends BaseModel {
  FechaInicioIt: Date;
  FechaFinIt: Date | null;
  IdEmpleado: string;
  FechaInicio: Date;
  FechaFin: Date | null;
  EmpleadoEnIt: Empleado;
  EmpleadoSustituto: Empleado;
  IdEmpleadoSustitucion: string;
  IdCliente: string;
  A3LItId: string;
  A3LItDescription: string;
}
